import { useLocation } from 'react-router';
import { noop } from 'libs';

const isActive = (location: { pathname: string }, paths: string[]) =>
  paths.reduce((accum, path) => {
    if (location.pathname.includes(path)) {
      return true;
    }
    return accum;
  }, false);

interface NavItemProps {
  disabled?: boolean;
  hidden?: boolean;
  onClick?: () => void;
  paths: string[];
  title?: string;
}

const NavItem = ({ disabled = false, hidden = false, onClick = noop, paths, title = '' }: NavItemProps) => {
  const location = useLocation();
  const classes = ['nav-item', 'nav-link'];

  if (hidden) {
    return null;
  }

  if (isActive(location, paths)) {
    classes.push('active');
  }

  return (
    <a key={title} className={classes.join(' ')} href={paths[0]} onClick={onClick} {...{ disabled }}>
      {title}
    </a>
  );
};

export default NavItem;
